var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"training"},[_c('div',{staticClass:"training__tiles"},_vm._l((_vm.assignments),function(assignment){return _c('training-tile',{key:assignment.id,attrs:{"assignment":assignment}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }